import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment'; 
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Checkbox, Button, FormControl, FormControlLabel, Grid, InputLabel, MenuItem,
         Paper, Select, Switch, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography
} from '@mui/material';
import Delete from '@mui/icons-material/Delete';

import CurrencyNumberFormat from '../ui/CurrencyNumberFormat';
import PercentageNumberFormat from '../ui/PercentageNumberFormat';

import VendorCommProgramUpdateMutation from './VendorCommProgramUpdateMutation';
import VendorCommProgramDeleteMutation from './VendorCommProgramDeleteMutation';
import VendorCommProgramLineCreateMutation from './VendorCommProgramLineCreateMutation';
import VendorCommProgramLineDeleteMutation from './VendorCommProgramLineDeleteMutation';
import VendorCommProgramLineUpdateMutation from './VendorCommProgramLineUpdateMutation';
import VendorCommProgramAppCreateMutation from './VendorCommProgramAppCreateMutation';
import VendorCommProgramAppDeleteMutation from './VendorCommProgramAppDeleteMutation';
import VendorCommProgramAppFetch from './VendorCommProgramAppFetch';

import CellContainer from '../ui/CellContainer';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import PageTitle from '../ui/PageTitle';
import SaveButton from '../ui/SaveButton';
import SavingSpinner from '../ui/SavingSpinner';
import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';
import AppBindStyles from '../../AppBindStyles';
import { getValueForRender } from '../../utils/InputUtils';

const abEnvironment = new AbEnvironment();
const VendorCommProgramEditQuery = graphql`
query VendorCommProgramEditQuery($cpId: UUID!) {
  cpTByCpId(cpId: $cpId) {
    accountId
    programName
    description
    programType
    notes
    publicView
    autoPayout
    paySubscriptionFees
    basedOnPartnersSalesFor
    payOutCommissionsEvery
    subscriptionsActiveAtLeast
    stopCommissionsAfter
    cpLineTsByCpId(orderBy:REVENUE_MIN_ASC) {
      totalCount
      nodes {
        cplId
        revenuePeriod
        revenueMin
        incentivePerc
      }
    }
    cpAppTsByCpId(orderBy: CREATED_ASC) {
      totalCount
      nodes {
        appId
        
      }
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      // color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    paperInner: {
      textAlign: 'left',
      // color: theme.palette.text.secondary,
      padding: theme.spacing(2)
    },
    numericTextField: {
      textAlign: 'right',
    },
    tblHead: {
      backgroundColor: '#f1f1f1'
    },    
    selectField: {
      width: 320,
      marginBottom: 8
    }
  });
  
class VendorCommProgramEdit extends Component {
  state = {
    // reFetch: 0,

    // Header
    programName:         null,
    description:         null,
    programType:         null,
    //qualificationPeriod: null,
    basedOnPartnersSalesFor: null,
    payOutCommissionsEvery: null, 
    subscriptionsActiveAtLeast: null,
    stopCommissionsAfter: null,
    notes:               null,
    publicView:          null,
    autoPayout:          null,
    paySubscriptionFees: null,

    // Lines.  These are null until set from props on a change.
    programLines:        null,
    // Lines to delete.  These are lines that need to be deleted on a save
    linesToDelete:       [],

    // New line
    revenueMin:           0,
    incentivePerc:        0,

    saveStatus:           null,
    saveMessage:          null,
    saveSnackbarOpen:     false,
    saveSnackbarDuration: null,
    saveClicked:          false,
    confirmDelete:        false,
    showSecondarySpinner: false,

    // app to delete.  These are apps that need to be deleted on a save
    appsToDelete:       [],
    appsToCreate:       [],

    appSelections:        [],
    noAppsDefined:        true,
    allAppsUsed:          true
  }

  // Focus set
  setFocusToNewLine = false;

  propProgramLines = null;
  nplCtr = 0;

  componentDidMount() {
    if (abEnvironment.isSegmentActive()) {  window.analytics.track('Editing a commissions program'); }

    const params = new URLSearchParams(this.props.location.search);
    let cpId = params.get('cpId');

    //this gets a list of all the vendor apps.
    let accountId = abEnvironment.getUserAttribute('a_id');
    VendorCommProgramAppFetch.fetch(accountId).toPromise()
    .then(vcpaf => {
      //console.log(cpId);
      let i = 0;
      let appSelections = [];
      let allAppsUsed = true;
      for (i = 0; i < vcpaf.allAppTs.nodes.length; i++) {
        let appT = vcpaf.allAppTs.nodes[i]
        if (appT.appStatus === 0 || appT.appStatus === 2 || appT.appStatus === 3) {
          let appName = '';
          if (appT.appSku == null || appT.appSku === '') {
            appName = appT.appName;
          } else {
            appName = appT.appName + " (" + appT.appSku + ")";
          }
          let appDisabled = false;
          let appSelected = false;
          let cpaId = null;
          let programName = null;
          if (appT.cpAppTsByAppId.totalCount === 0) {
            allAppsUsed = false;
            
          } else {
            //console.log(appT.cpAppTsByAppId.nodes[0].cpTByCpId.cpId);
            if (appT.cpAppTsByAppId.nodes[0].cpTByCpId.cpId !== cpId) {
              appDisabled = true;
              programName = appT.cpAppTsByAppId.nodes[0].cpTByCpId.programName
            }
            if (appT.cpAppTsByAppId.nodes[0].cpTByCpId.cpId === cpId) {
              appSelected = true;
              allAppsUsed = false;
              cpaId = appT.cpAppTsByAppId.nodes[0].cpaId
            }

          }

          let appSelection = {'appId' : appT.appId, 'appName': appName, 'selected' : appSelected, 'existingInDB' : appSelected, 'disabled': appDisabled, 'cpaId': cpaId, 'programName': programName, 'appStatus': appT.appStatus};
          appSelections.push(appSelection);
        }
      }

      if (appSelections.length > 0 && !allAppsUsed) {
        this.setState({ noAppsDefined: false, allAppsUsed: false, appSelections: appSelections});
      } else if (allAppsUsed) {
        this.setState({ noAppsDefined: false, allAppsUsed: allAppsUsed, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'All apps in app catalog have already been assigned to a commission plan.', saveSnackbarDuration: null });
      } else {
        this.setState({ noAppsDefined: true, allAppsUsed: allAppsUsed, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Please define your apps in catalog before setting up commission plan.', saveSnackbarDuration: null });
      }
  
    })
    .catch(err => {
      //nothing to do....
    })
    
  }

  // Get lines.  If line state is null, this means nothing has changed from the initial render.  So props
  // is the source of truth.  However, once something change, state is the source of truth.  This method is
  // a convenience to return state if state exists, and props if it doesn't.
  getLines() {
    if (this.state.programLines != null)
      return this.state.programLines;

    if (this.propProgramLines != null)
      return this.propProgramLines;

    return null;
  }

  changeProgramType = ( newType ) => {
    this.setState({programType: newType});
  }

  /*
   * This method expects a cell key (key on the individual component reporting a change),
   * and a row key (this will be the plId - program line id)
   */
  handleChangedCell = (cKey, rKey, value) => {
    // Find the programLine corresponding to the rKey, and then use the cKey to find which
    // attribute this is for.
    let mLines = [];
    let lines = this.getLines();
    if (lines == null || lines.length === 0) {
      // should never happen
      return;
    }

    for (let i=0; i<lines.length; i++) {
      let theLine = lines[i];
      if (theLine.cplId === rKey) {
        let changedLine = null;
        if (cKey.startsWith('mr')) {
          changedLine = {cplId: theLine.cplId, revenueMin: value, incentivePerc: theLine.incentivePerc}
        } else {
          changedLine = {cplId: theLine.cplId, revenueMin: theLine.revenueMin, incentivePerc: value}
        }
        mLines.push(changedLine);
      } else {
        mLines.push(theLine);
      }
    }
    mLines.sort((a, b) => (Number.parseFloat(a.revenueMin) > Number.parseFloat(b.revenueMin)) ? 1 : -1);  
    this.setState({programLines: mLines, revenueMin: 0, incentivePerc: 0});
  }

  /*
   * Remove a program line from the state.  Replace the program line array.
   * Use the key, which should be the plId, to identify the line for removal.
   */
  deleteProgramLine(deleteId) {
    let mLines = [];
    let lineToDelete = null;
    let lines = this.getLines();
    if (lines == null || lines.length === 0) {
      // should never happen
      return;
    }

    for (let i=0; i<lines.length; i++) {
      let theLine = lines[i];
      if (theLine.cplId === deleteId) {
        if (! deleteId.startsWith('pl-')) {
          lineToDelete = theLine; // This will be added to a list of lines to be deleted from the db
        }
      } else {
        mLines.push(theLine);
      }
    }

    // If there is a line to delete, add it to the state list of lines to delete
    let deleteLines = [];
    if (lineToDelete != null) {
      for (let i=0; i<this.state.linesToDelete.length; i++) {
        deleteLines.push(this.state.linesToDelete[i]);
      }
      deleteLines.push(lineToDelete);
    }

    this.setState({programLines: mLines, linesToDelete: deleteLines});
  }

  // Add a program line.
  addProgramLine(theComponent) {  
    let lines = this.getLines();

    // Don't add the line if revenueMin hasn't been set
    if (this.state.revenueMin == null) {
      this.setFocusToNewLine = false;
      return;
    }

    // If the component is revenueMin and incentivePerc is 0, dont't add the line
    if (theComponent === "revenueMin" && Number.parseFloat(this.state.incentivePerc) === 0) {
      this.setFocusToNewLine = false;
      return;
    }

    // If there is already a line with the same minimum revenue, don't add the line
    for (let i = 0; i < lines.length; i++) {
      let line = lines[i]; 
      if (Number.parseFloat(line.revenueMin) === Number.parseFloat(this.state.revenueMin)) {
        this.setFocusToNewLine = false;
        return;
      }
    }

    this.setFocusToNewLine = true;

    let mLines = [];
    let tempPlId = 'pl-' + this.nplCtr;
    this.nplCtr++;
    let newLine = {cplId: tempPlId, revenueMin: this.state.revenueMin, incentivePerc: this.state.incentivePerc}   
    
    //add the lines, push the new one, sort and reset state
    for (let i = 0; i < lines.length; i++) {
      let line = lines[i]; 
      mLines.push(line);
    }

    mLines.push(newLine);
    mLines.sort((a, b) => (Number.parseFloat(a.revenueMin) > Number.parseFloat(b.revenueMin)) ? 1 : -1);
    
    this.setState({programLines: mLines, revenueMin: 0, incentivePerc: 0});
  }

  isAppSelected = () => {
    
    if (!this.state.appSelections.length > 0) {
      return false;
    }

    let oneAppSelected = false;
    let i = 0;
    for (i = 0; i < this.state.appSelections.length; i++) {
      let appT = this.state.appSelections[i]
      if (appT.selected === true) {
        oneAppSelected = true;
        break;
      }
    }
    if (oneAppSelected === true) {
      return true;
    } else {
      return false;
    }

  }

  updateAppSelection = (appIdToggled) => {

    let appsToDelete = this.state.appsToDelete;
    let appsToCreate = this.state.appsToCreate;
    let mutableArray = [];
    let i = 0;
    //console.log(appIdToggled);
    for (i = 0; i < this.state.appSelections.length; i++) {
      let app = this.state.appSelections[i];
      if (app.appId === appIdToggled) {
        //console.log(JSON.stringify(app));
        if (!app.selected) {
          if (!app.existingInDB) {
            appsToCreate.push(app);
          }

        } else if (app.selected && app.existingInDB) {
          appsToDelete.push(app);
        } else if (app.selected && !app.existingInDB) {
          //remove from appsToCreate if needed since it will be now unselected.
          let y = 0;
          for (y = 0; y < this.state.appsToCreate.length; y++) {
            let appToRemove = appsToCreate[y];
            if (appToRemove.appId === appIdToggled) {
              appsToCreate.splice(y,1);
              break;
            }
          }
        }

        app.selected = !app.selected;
      } 
      mutableArray.push(app);
    }

    //console.log('appsToCreate=' + JSON.stringify(appsToCreate));
    //console.log('appsToDelete=' + JSON.stringify(appsToDelete));

    this.setState({appSelections: mutableArray, appsToCreate: appsToCreate, appsToDelete: appsToDelete});
  }


  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  goBack() {
    this.props.history.goBack();
  }
  
  showSecondarySpinner() {
    return this.state.showSecondarySpinner;
  }

  onSnackbarClose() {
    this.setState( {saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null });
  }

  isRequiredFieldInError = (state_member) => {
    if (state_member === '') {
      return 'Field is required';
    } else {
      return '';
    }
  }

  /**
   * Is the minimum revenue value bad?
   */
  isMinRevError = (revkey, value) => {
    let revenueMinValue = Number.parseFloat(value);

    if (revkey != null) {
      if (revenueMinValue < 0) {
        return true;
      }

      // get the plId from the revkey
      let cplId = revkey;
      if (revkey != null && revkey.startsWith('mr-') && revkey.length > 4) {
        cplId = revkey.substring(3);
      }

      let lines = this.getLines();
      for (let i = 0; i < lines.length; i++) {
        let line = lines[i];
        if (line.cplId === cplId)
          continue;

        if (Number.parseFloat(line.revenueMin) === revenueMinValue) {
          return true;
        }
      }
    }

    return false;
  }

  /*
   * Get helper text for a bad minimum revenue value
   */
  getMinRevHelper = (revkey, value) => {
    let revenueMinValue = Number.parseFloat(value);

    if (revkey != null) {
      if (revenueMinValue < 0) {
        return 'Revenue minimum value cannot be negative';
      }

      // get the plId from the revkey
      let cplId = revkey;
      if (revkey != null && revkey.startsWith('mr-') && revkey.length > 4) {
        cplId = revkey.substring(3);
      }

      let lines = this.getLines();
      for (let i = 0; i < lines.length; i++) {
        let line = lines[i];
        if (line.cplId === cplId)
          continue;
        if (Number.parseFloat(line.revenueMin) === revenueMinValue) {
          return 'This revenue minimum value is already used';
        }
      }
    }

    return '';
  }

  /*
   * Determine if lines are in a savable state.  Currently this
   * will simply verify that there are no entries with duplicate minimum
   * revenue values.
   */
  areLinesUnsavable() {
    let programLines = this.getLines();
    if (programLines != null && programLines.length > 0) {
      // For each line, add either an insert or an update mutation promise.
      for (let i=0; i<programLines.length; i++) { 
        let theLine = programLines[i];

        // theLine.revenueMin
        for (let j=i+1; j<programLines.length; j++) {
          let compareLine = programLines[j];
          let lineNum = Number(theLine.revenueMin)
          let compareNum = Number(compareLine.revenueMin);
          if (lineNum === compareNum) {
            // duplicate identified
            return true;
          }
        }

      }
    }
    return false;
  }

  /*
   * Determine if lines are changed in some way
   */
  areLinesChanged(program) {
    if (this.state.programLines != null) {

     if (this.state.programLines.length !== program.cpLineTsByCpId.nodes.length) {
        return true;
      }

      for (let i=0; i<this.state.programLines.length; i++) { 
        let theLine = this.state.programLines[i];

        // theLine.revenueMin
          let compareLine = program.cpLineTsByCpId.nodes[i];
          let lineNum = Number(theLine.revenueMin)
          let compareNum = Number(compareLine.revenueMin);

          let lineNumPerc = Number(theLine.incentivePerc)
          let compareNumPerc = Number(compareLine.incentivePerc);

          if (lineNum !== compareNum) {
            return true;
          }
          if (lineNumPerc !== compareNumPerc) {
            return true;
          }

      }

    }
    return false;

  }

  disableSave(programProps) {

    /*
    if (!this.isAppSelected()) {
      return true;
    }
    */
    if (this.isRequiredFieldInError(this.state.programName) !== '')
      return true;
  
    if (this.isRequiredFieldInError(this.state.description) !== '')
      return true;

    if (this.areLinesUnsavable())
      return true;

    // See if there is anything to save
    let somethingChanged = false;
    if (this.state.programName != null && this.state.programName !== programProps.programName)
      somethingChanged = true;
    if (this.state.publicView != null && this.state.publicView !== programProps.publicView)
      somethingChanged = true;
    if (this.state.description != null && this.state.description !== programProps.description)
      somethingChanged = true;
    if (this.state.notes != null && this.state.notes !== programProps.notes)
      somethingChanged = true;
    if (this.state.programType != null && this.state.programType !== programProps.programType)
      somethingChanged = true;
    /*if (this.state.qualificationPeriod != null && this.state.qualificationPeriod !== programProps.qualificationPeriod)
      somethingChanged = true;*/
    if (this.state.basedOnPartnersSalesFor != null && this.state.basedOnPartnersSalesFor !== programProps.basedOnPartnersSalesFor)
      somethingChanged = true;
    if (this.state.payOutCommissionsEvery != null && this.state.payOutCommissionsEvery !== programProps.payOutCommissionsEvery)
      somethingChanged = true;
    if (this.state.subscriptionsActiveAtLeast != null && this.state.subscriptionsActiveAtLeast !== programProps.subscriptionsActiveAtLeast)
      somethingChanged = true;
    if (this.state.stopCommissionsAfter != null && this.state.stopCommissionsAfter !== programProps.stopCommissionsAfter)
      somethingChanged = true;
    if (this.state.autoPayout != null && this.state.autoPayout !== programProps.autoPayout)
      somethingChanged = true;
    if (this.state.paySubscriptionFees != null && this.state.paySubscriptionFees !== programProps.paySubscriptionFees)
      somethingChanged = true;
 
    if (!somethingChanged) {
      somethingChanged =  this.areLinesChanged(programProps);
    }

    if (!somethingChanged) {
      if (this.state.appsToDelete.length > 0 || this.state.appsToCreate.length > 0) {
        somethingChanged = true;
      }
    }

    if (somethingChanged) {
      return false;
    }

    return true;
  }

  appValidForType(app, program) {
    let programType = getValueForRender(this.state.programType, program.programType, 0);

    if ((programType === 4) && (app.appStatus === 3)) {
      return true;
    } else if ((programType !== 4) && (app.appStatus !== 3)) {
      return true;
    } else {
      return false;
    }
  }
  render() {
    const { isAuthenticated, isAuthenticatedVendor, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedVendor()) {
      const params = new URLSearchParams(this.props.location.search);

      let cpId = params.get('cpId');
      let appCounter = 0;

      let fp = params.get('fp');
      let backTo = "Plans";
      if (fp != null && fp !== '') {
        backTo = fp;
      }

      let setFocusToNewLine = this.setFocusToNewLine;

      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={VendorCommProgramEditQuery}
          variables={{cpId: cpId}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              let program = props.cpTByCpId;

              // Now that we have props from the query, we can setup program lines for rendering.  But if state has been
              // set, we should use the state values.  We'll determine which to use through a convenience method.
              if (program && program.cpLineTsByCpId && program.cpLineTsByCpId.nodes) {
                this.propProgramLines = program.cpLineTsByCpId.nodes;
              }

              let programLines = this.getLines();

              /*
              let deleteHeader = 'Add';
              if (programLines && programLines.length > 0) {
                deleteHeader = 'Delete';
              }
              */
              let programTypeString = '';
              if (program.programType === 0) {
                programTypeString = 'instant rebate';
              } else if (program.programType === 1) {
                programTypeString = 'monthly rebate';
              } else if (program.programType === 2) {
                programTypeString = 'monthly credits';   //not used right now
              } else if (program.programType === 3) {
                programTypeString = 'prepaid credits';   //not used right now
              } else if (program.programType === 4) {
                programTypeString = 'referral commission';
              }

              return (
                <Grid container spacing={3} direction="row" justifyContent="flex-start">
                  <Grid item xs={12}>
                    <PageTitle title="Manage commission plan" showBackButton={true} name={backTo} noMargin={true} history={this.props.history}/>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                            <Grid item>
                              <Typography variant="h6">{getValueForRender(this.state.programName, program.programName, '')}</Typography>
                            </Grid>
                            <Grid item>
                              <Grid container spacing={1} alignItems="center">
                                <Grid item>
                                  <Typography variant="body1">Active</Typography>
                                </Grid>
                                <Grid item>
                                  <Switch
                                    checked={getValueForRender(this.state.publicView,  program.publicView, '') === 1}
                                    onChange={(e, checked) => {
                                      if (getValueForRender(this.state.publicView,  program.publicView, '') === 1) {
                                        this.setState({ publicView: 0});
                                      } else {
                                        this.setState({ publicView: 1});
                                      }
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Paper className={classes.paperInner}>
                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <Typography variant="h6">{'About this ' + programTypeString + ' plan'}</Typography>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <TextField 
                                  error={this.isRequiredFieldInError(this.state.programName) !== ''}
                                  id="program-name" label="Commission plan name *"
                                  value={getValueForRender(this.state.programName, program.programName, '')}
                                  onChange={(e) => this.setState({ programName: e.target.value })}
                                  inputProps={{ maxLength: 64 }}
                                  helperText={this.isRequiredFieldInError(this.state.programName)}
                                />
                              </Grid>
                              <Grid item  xs={12}>
                                <TextField 
                                  error={this.isRequiredFieldInError(this.state.description) !== ''}
                                  id="description" label="Description *"
                                  value={getValueForRender(this.state.description, program.description, '')}
                                  onChange={(e) => this.setState({ description: e.target.value })}
                                  inputProps={{ maxLength: 2048 }}
                                  fullWidth
                                  multiline
                                  helperText={this.isRequiredFieldInError(this.state.description)}
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <Grid container spacing={1} justifyContent="space-between">
                                  <Grid item>
                                    <Typography variant="body1">
                                    Cover partner AppBind fees
                                    </Typography>
                                  </Grid>
                                  <Grid item>
                                    <Switch
                                      checked={getValueForRender(this.state.paySubscriptionFees, program.paySubscriptionFees, '') === 1}
                                      onChange={() => {
                                        if (getValueForRender(this.state.paySubscriptionFees, program.paySubscriptionFees, '') === 1) {
                                          this.setState({ paySubscriptionFees: 0});
                                        } else {
                                          this.setState({ paySubscriptionFees: 1});
                                        }
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12}>
                                <TextField 
                                  id="notes" label="Notes"
                                  value={getValueForRender(this.state.notes,  program.notes, '')}
                                  onChange={(e) => this.setState({ notes: e.target.value })}
                                  fullWidth
                                  multiline
                                  inputProps={{ maxLength: 2048 }}
                                />
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        <Grid item xs={12}>
                          <Paper className={classes.paperInner}>
                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <Typography variant="h6">Commission incentives</Typography>
                                <Typography variant="body2">
                                  Configure tiered commission incentives based on the amount of sales a partner generates for you
                                </Typography>
                              </Grid>
                              <Grid item xs={6}> 
                                <FormControl variant="standard" className={classes.selectField}>
                                  <InputLabel>Based on partner sales for past (months)</InputLabel>
                                  <Select
                                    value={getValueForRender(this.state.basedOnPartnersSalesFor,  program.basedOnPartnersSalesFor, 1)}
                                    onChange={(e) => { this.setState({ basedOnPartnersSalesFor: e.target.value });  } }
                                    inputProps={{
                                      name: 'basedOnPartnersSalesFor',
                                      id: 'basedOnPartnersSalesFor',
                                    }}
                                  >
                                    <MenuItem value={-1}>All Time</MenuItem>
                                    {/* "MenuItem" entries from 1 to 12 with value = i and display = i for each. */}
                                    { [...Array(12).keys()].map((i) => {
                                      i = i+1;
                                      return(<MenuItem key={i} value={i}>{i}</MenuItem>)
                                    })}

                                  </Select>
                                </FormControl>
                              </Grid>
                              {getValueForRender(this.state.programType, program.programType, 0) !== 1 &&
                              <Grid item xs={6}> 
                                <FormControl variant="standard" className={classes.selectField}>
                                  <InputLabel>Pay out commissions every (months)</InputLabel>
                                  <Select
                                    value={getValueForRender(this.state.payOutCommissionsEvery,  program.payOutCommissionsEvery, '')}
                                    onChange={(e) => { this.setState({ payOutCommissionsEvery: e.target.value });  } }
                                    inputProps={{
                                      name: 'payOutCommissionsEvery',
                                      id: 'payOutCommissionsEvery',
                                    }}
                                    >
                                    {/* "MenuItem" entries from 1 to 12 with value = i and display = i for each. */}
                                    { [...Array(12).keys()].map((i) => {
                                      i = i+1;
                                      return(<MenuItem key={i} value={i}>{i}</MenuItem>)
                                    })}

                                  </Select>
                                </FormControl>
                              </Grid>}
                              <Grid item xs={6}> 
                                <FormControl variant="standard" className={classes.selectField}>
                                  <InputLabel>For subscriptions active after (months)</InputLabel>
                                  <Select
                                    value={getValueForRender(this.state.subscriptionsActiveAtLeast,  program.subscriptionsActiveAtLeast, '')}
                                    onChange={(e) => { this.setState({ subscriptionsActiveAtLeast: e.target.value });  } }
                                    inputProps={{
                                      name: 'subscriptionsActiveAtLeast',
                                      id: 'subscriptionsActiveAtLeast',
                                    }}
                                  >
                                    <MenuItem value={0}>Immediately</MenuItem>
                                    {/* "MenuItem" entries from 1 to 12 with value = i and display = i for each. */}
                                    { [...Array(12).keys()].map((i) => {
                                      i = i+1;
                                      return(<MenuItem key={i} value={i}>{i}</MenuItem>)
                                    })}

                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={6}> 
                                <FormControl variant="standard" className={classes.selectField}>
                                  <InputLabel>Stop commissions after (months)</InputLabel>
                                  <Select
                                    value={getValueForRender(this.state.stopCommissionsAfter,  program.stopCommissionsAfter, -1)}
                                    onChange={(e) => { this.setState({ stopCommissionsAfter: e.target.value });  } }
                                    inputProps={{
                                      name: 'stopCommissionsAfter',
                                      id: 'stopCommissionsAfter',
                                    }}
                                  >
                                    <MenuItem value={-1}>Never</MenuItem>
                                    {/* "MenuItem" entries from 1 to 60 with value = i and display = i for each. */}
                                    { [...Array(60).keys()].map((i) => {
                                      i = i+1;
                                      return(<MenuItem key={i} value={i}>{i}</MenuItem>)
                                    })}

                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={12}>
                                <TableContainer>
                                  <Table>
                                    <TableHead className={classes.tblHead}>
                                      <TableRow>
                                        <TableCell align="right">Minimum sales</TableCell>
                                        <TableCell align="right">Incentive percentage</TableCell>
                                        <TableCell/>
                                        {/*<TableCell align="center">{deleteHeader}</TableCell>*/}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {
                                      // this.state.programLines && this.state.programLines.map(line => {
                                      programLines && programLines.map(line => {
                                        let revKey  = 'mr-' + line.cplId;
                                        let revenue = line.revenueMin;
                                        let perKey  = 'ip-' + line.cplId;
                                        let perc    = line.incentivePerc;

                                        return (
                                          <TableRow key={line.cplId}>
                                            <TableCell align="right">
                                              <CellContainer
                                                cellKey={revKey}
                                                rowKey={line.cplId}
                                                id={revKey}
                                                fieldtype='currency'
                                                minValue={0}
                                                value={revenue}
                                                onChangedValue={this.handleChangedCell}
                                                isError={this.isMinRevError}
                                                fieldHelper={this.getMinRevHelper}
                                              />
                                            </TableCell>
                                            <TableCell align="right">
                                              <CellContainer
                                                cellKey={perKey}
                                                rowKey={line.cplId}
                                                id={perKey}
                                                fieldtype='percentage'
                                                value={perc}
                                                onChangedValue={this.handleChangedCell}
                                              />
                                            </TableCell>
                                            <TableCell align="center" >
                                              <Button
                                                className={classes.iconbutton}
                                                onClick={() => { this.deleteProgramLine(line.cplId); }}>
                                                <Delete color="primary"/>
                                              </Button>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                      <TableRow >
                                        <TableCell align="right" >
                                          {setFocusToNewLine &&
                                          <TextField
                                            inputRef={input => input && input.focus() }
                                            className={classes.numericTextField}
                                            id="min-rev" label="" 
                                            value={this.state.revenueMin}
                                            onChange={(e) => this.setState({ revenueMin: e.target.value })}
                                            onBlur={() => { this.addProgramLine("revenueMin"); }}
                                            InputProps={{
                                              inputComponent: CurrencyNumberFormat
                                            }}
                                            inputProps={{
                                              minValue: 0,
                                              style: { textAlign: "right" }
                                            }}
                                          />}
                                          {! setFocusToNewLine &&
                                          <TextField
                                            className={classes.numericTextField}
                                            id="min-rev" label="" 
                                            value={this.state.revenueMin}
                                            onChange={(e) => this.setState({ revenueMin: e.target.value })}
                                            onBlur={() => { this.addProgramLine("revenueMin"); }}
                                            InputProps={{
                                              inputComponent: CurrencyNumberFormat
                                            }}
                                            inputProps={{
                                              minValue: 0,
                                              style: { textAlign: "right" }
                                            }}
                                          />}
                                        </TableCell>
                                        {/*
                                            error={this.isMinRevError(null, this.state.revenueMin)}
                                            helperText={this.getMinRevHelper(null, this.state.revenueMin)}
                                        */}
                                        <TableCell align="right" >
                                          <TextField className={classes.numericTextField}
                                            error={this.isRequiredFieldInError(this.state.incentivePerc) !== ''}
                                            id="incent-perc" label="" 
                                            value={this.state.incentivePerc}
                                            onChange={(e) => this.setState({ incentivePerc: e.target.value })}
                                            onBlur={() => { this.addProgramLine("incentivePerc"); }}
                                            InputProps={{
                                              inputComponent: PercentageNumberFormat,
                                            }}
                                            inputProps={{
                                              minValue: 0,
                                              maxValue: 100,
                                              style: { textAlign: "right" }
                                            }}
                                          />
                                        </TableCell>
                                        {/*
                                            helperText={this.isRequiredFieldInError(this.state.incentivePerc)}
                                        */}
                                        <TableCell align="center" >
                                          {/* 
                                          <Button color="default" onClick={() => { this.addProgramLine();  }}>
                                            <Add color="primary"/>
                                          </Button>
                                          */}                    
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        <Grid item xs={12}>
                          <Paper className={classes.paperInner}>
                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <Typography variant="h6">Payout approvals</Typography>
                                <Typography variant="body2">
                                  Control when incentives are paid out
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Grid container spacing={1} justifyContent="space-between">
                                  <Grid item>
                                    <Typography variant="body1">
                                      Automatically pay out incentives
                                    </Typography>
                                  </Grid>
                                  <Grid item style={{padding:0}}>
                                    <Switch
                                      checked={getValueForRender(this.state.autoPayout,  program.autoPayout, '') === 1}
                                      onChange={(e, checked) => {
                                        if (getValueForRender(this.state.autoPayout,  program.autoPayout, '') === 1) {
                                          this.setState({ autoPayout: 0});
                                        } else {
                                          this.setState({ autoPayout: 1});
                                        }
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        <Grid item xs={12}>
                          <Paper className={classes.paperInner}>
                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <Typography variant="h6">Apps in this plan</Typography>
                                <Typography variant="body2">
                                  Select the apps that are in this plan
                                </Typography>
                              </Grid>

                              <Grid item xs={12}>
                                <Grid container spacing={0}>                      
                                  { this.state.appSelections.map(n => {
                                    //console.log(JSON.stringify(n));
                                    if (n.disabled === true) {
                                      let tooltip = n.appName + ' is already in plan ' + n.programName;
                                      return (
                                        <Grid item key={(appCounter++).toString()} style={{width: '420px'}}>
                                          <Tooltip placement='right' title={tooltip}>
                                            <FormControlLabel 
                                              control={<Checkbox checked={n.selected} disabled={true}/>}
                                              label={n.appName}
                                            />
                                          </Tooltip>
                                        </Grid>
                                      );
                                    } else {
                                      if (!this.appValidForType(n, program)) {
                                        let tooltip = n.appName + ' is not valid for this type of plan';
                                        return (
                                          <Grid item key={(appCounter++).toString()} style={{width: '420px'}}>
                                            <Tooltip placement='right' title={tooltip}>
                                            <FormControlLabel 
                                              control={<Checkbox checked={n.selected} disabled={true} />}
                                              label={n.appName}
                                            />
                                            </Tooltip>
                                          </Grid>
                                        );
    
                                      }
                                      return (
                                        <Grid item key={(appCounter++).toString()} style={{width: '420px'}}>
                                          <FormControlLabel 
                                            control={<Checkbox checked={n.selected} disabled={false}  onChange={() => this.updateAppSelection(n.appId)}/>}
                                            label={n.appName}
                                          />
                                        </Grid>
                                      );
                                    }
                                  })}
                                </Grid>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        <Grid item >
                          <SaveButton
                            snackbarOpen={this.state.saveSnackbarOpen}
                            autoHideDuration={this.state.saveSnackbarDuration}
                            label="Save"
                            status={this.state.saveStatus} 
                            message={this.state.saveMessage}
                            onSaveClick={() => { this.updateProgram(cpId, program); }}
                            onSnackbarClose={() => { this.onSnackbarClose(); }}
                            disabled={this.disableSave(program)}
                          />

                          {this.showSecondarySpinner() &&
                            <Button color="primary" variant="outlined" style={AppBindStyles.bottomButton}>
                              <SavingSpinner/>
                            </Button>
                          }

                          {!this.showSecondarySpinner() &&
                            <Button variant="outlined" color="primary" 
                            disabled={false}
                            style={AppBindStyles.bottomButton} onClick={() => { this.setState({confirmDelete:true}); }}>
                              <Delete color="primary"/> Delete
                            </Button>
                          }
                          <ConfirmationDialog
                              open={this.state.confirmDelete}
                              onClose={() => { this.setState({confirmDelete:false});}}
                              onConfirm={() => { this.deleteProgram(cpId); }}
                              onCancel={() => { }}
                              title="Delete program?"
                              cancelBtn="Cancel"
                              okBtn="Ok"
                            >
                              Are you sure you want to delete this incentive program?
                          </ConfirmationDialog> 
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              );
            }
            return <LoadingSpinner />
          }}
        />
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }

  /*
   * Update the program.  
   * 1) Update information on the program.
   * 2) Iterate through lines to delete, deleting them
   * 3) Iterate through program lines, inserting new ones and updating existing ones if needed.  
   */
  updateProgram = (cpId, program) => {
    if (this.disableSave(program)) {
      return;
    }
    this.setState({ saveStatus: 'saving' });
    const { programName, description, programType, basedOnPartnersSalesFor, payOutCommissionsEvery, subscriptionsActiveAtLeast, stopCommissionsAfter, 
            notes, publicView, autoPayout, paySubscriptionFees,
            programLines, linesToDelete, appsToDelete, appsToCreate } = this.state;

    let deletePromiseArray = [];
    let updatePromiseArray = [];
    let deleteAppPromiseArray = [];
    let createAppPromiseArray = [];

    VendorCommProgramUpdateMutation.commit(cpId, programName, description, programType, basedOnPartnersSalesFor, payOutCommissionsEvery, subscriptionsActiveAtLeast, stopCommissionsAfter, notes, publicView, autoPayout, paySubscriptionFees)
    .then(response => {
      //handle initial response?

      // Are there any apps to delete?
      if (appsToDelete != null && appsToDelete.length > 0) {
        // For each app to delete, create a delete mutation promise.
        for (let i=0; i<appsToDelete.length; i++) {
          let cpaId = appsToDelete[i].cpaId;
          let deletePromise = VendorCommProgramAppDeleteMutation.commit(cpaId);
          deleteAppPromiseArray.push(deletePromise);
        }

        // Sequentially execute the delete mutations
        return deleteAppPromiseArray.reduce((promiseChain, currentPromise) => {
          return promiseChain.then(chainResults => 
            currentPromise.then(currentResult => 
              [ ...chainResults, currentResult ]
            )
          );
        }, Promise.resolve([])).then(resultsArray => {
          return resultsArray;
        })
      }
      return null;
    })
    .then(dresp => {
      // Are there any apps to create?
      if (appsToCreate != null && appsToCreate.length > 0) {
        // For each line, add either an insert or an update mutation promise.
        for (let i=0; i<appsToCreate.length; i++) {
          let theApp = appsToCreate[i];
          let createPromise = VendorCommProgramAppCreateMutation.commit(cpId, theApp.appId);
          createAppPromiseArray.push(createPromise);

        }

        // Sequentially execute the create mutations
        return createAppPromiseArray.reduce((promiseChain, currentPromise) => {
          return promiseChain.then(chainResults => 
            currentPromise.then(currentResult => 
              [ ...chainResults, currentResult ]
            )
          );
        }, Promise.resolve([])).then(resultsArray => {
          return resultsArray;
        })
      }
      return null;
    })
    .then(response => {
      // Are there any lines to delete?
      if (linesToDelete != null && linesToDelete.length > 0) {
        // For each line to delete, create a delete mutation promise.
        for (let i=0; i<linesToDelete.length; i++) {
          let cplId = linesToDelete[i].cplId;
          let deletePromise = VendorCommProgramLineDeleteMutation.commit(cplId);
          deletePromiseArray.push(deletePromise);
        }

        // Sequentially execute the delete mutations
        return deletePromiseArray.reduce((promiseChain, currentPromise) => {
          return promiseChain.then(chainResults => 
            currentPromise.then(currentResult => 
              [ ...chainResults, currentResult ]
            )
          );
        }, Promise.resolve([])).then(resultsArray => {
          return resultsArray;
        })
      }
      return null;
    })
    .then(dresp => {
      // Are there any lines to update?
      if (programLines != null && programLines.length > 0) {
        // For each line, add either an insert or an update mutation promise.
        for (let i=0; i<programLines.length; i++) {
          let theLine = programLines[i];
          if (theLine.cplId.startsWith('pl-')) {
            // insert
            let createPromise = VendorCommProgramLineCreateMutation.commit(cpId, theLine.revenuePeriod, theLine.revenueMin, theLine.incentivePerc);
            updatePromiseArray.push(createPromise);
          } else {
            // update
            let updatePromise = VendorCommProgramLineUpdateMutation.commit(theLine.cplId, theLine.revenuePeriod, theLine.revenueMin, theLine.incentivePerc);
            updatePromiseArray.push(updatePromise);
          }
        }

        // Sequentially execute the delete mutations
        return updatePromiseArray.reduce((promiseChain, currentPromise) => {
          return promiseChain.then(chainResults => 
            currentPromise.then(currentResult => 
              [ ...chainResults, currentResult ]
            )
          );
        }, Promise.resolve([])).then(resultsArray => {
          return resultsArray;
        })
      }
      return null;
    })
    .then(uresp => {
      // Just reload to refresh information
      window.location.reload();

      // If we refreshed appropriately from mutation returns, would do the snackbar:
      //refetch for the query renderer, clear the state variable changes, then explicitly call componentDidMount... easier to reload
      // let fetch = this.state.reFetch;
      // fetch++;
      // this.setState({reFetch: fetch, saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'Plan saved.', saveSnackbarDuration: 3000});
      // this.componentDidMount();

      // If we returned to programs list, would do this:
      //this.goTo("programs");
    })
    .catch(error => {
      //console.log(error);
      this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Unable to save commission plan', saveSnackbarDuration: null });
    });                      
  }

  /*
   * Delete the program.  
   * 1) Delete all program lines.
   * 2) Delete the program.
   */
  deleteProgram = (cpId) => {
    /*
    if (this.disableSave()) {
      return;
    }
    */
    this.setState({ showSecondarySpinner: true });

    const {  linesToDelete, appSelections } = this.state;

    let deletePromiseArray = [];

    let programLines = this.getLines();

    Promise.resolve()
    .then(() => {
      if (programLines != null && programLines.length > 0) {
        // For each line, delete unless it hasn't been added yet.
        for (let i=0; i<programLines.length; i++) {
          let theLine = programLines[i];
          let cplId = theLine.cplId;
          if (! cplId.startsWith('pl-')) {
            let deletePromise = VendorCommProgramLineDeleteMutation.commit(cplId);
            deletePromiseArray.push(deletePromise);
          }
        }
      }

      if (appSelections != null && appSelections.length > 0) {
        // For each line to delete, create a delete mutation promise.
        for (let i=0; i<appSelections.length; i++) {
          let cpaId = appSelections[i].cpaId;
          if (cpaId !== null) {
            let deletePromise = VendorCommProgramAppDeleteMutation.commit(cpaId);
            deletePromiseArray.push(deletePromise);
          }
        }
      }

      if (linesToDelete != null && linesToDelete.length > 0) {
        // For each line to delete, create a delete mutation promise.
        for (let i=0; i<linesToDelete.length; i++) {
          let cplId = linesToDelete[i].cplId;
          let deletePromise = VendorCommProgramLineDeleteMutation.commit(cplId);
          deletePromiseArray.push(deletePromise);
        }
      }

      if (deletePromiseArray.length > 0) {
        // Sequentially execute the delete mutations
        return deletePromiseArray.reduce((promiseChain, currentPromise) => {
          return promiseChain.then(chainResults => 
            currentPromise.then(currentResult => 
              [ ...chainResults, currentResult ]
            )
          );
        }, Promise.resolve([])).then(resultsArray => {
          return resultsArray;
        })
      }
      return null;
    })
    .then(ldresp => {
      // Delete the program
      return VendorCommProgramDeleteMutation.commit(cpId);
    })
    .then(dresp => {
      this.setState({ saveStatus: 'success' });
      this.goTo("commprograms");
    })
    .catch(error => {
      //console.log(error);
      this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Unable to delete commission plan', saveSnackbarDuration: null });
    });                      
  }
}

VendorCommProgramEdit.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(VendorCommProgramEdit);
